import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import close from "../../../assets/images/close.png";
import copy from "../../../assets/images/copy.png";
import {
  Modal,
  ModalBody, ModalHeader
} from 'reactstrap';
import axiosInstance from '../../../helpers/axios';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export default function PaymentLink({selectedItems,selectedEmiStatuses,totalEmiAmount,loanDetails,overdueCharges,chequeBounceCharges,interest,isPreClosure,discountedBounce,discountedPenalty,paidBounce,paidPenalty,paidPrinciple,paidInterest,principle,foreCloseAmount,futureInterest}){
    
    const [amount, setamount] = useState('');
    const [lumpsumAmount, setLumpsumAmount] = useState('');
    const [penaltyAmount, setPenaltyAmount] = useState('');
    const [bounceCharges, setBounceCharges] = useState('');
    const [discountAmount, setDiscountAmount] = useState('');
    const [totalAmount, setTotalAmount] = useState("");
    const [confirmationMessage, setConfirmationMessage] = useState('Hold On...');
    const [formStatusOpen, setStatusOpen] = useState(false);
    const [RepaymentType, setRepaymentType] = useState('Select');
    const [paymentLink,setPaymentLink] = useState(null)
    const [showPaymentLinkModal, setShowPaymentLinkModal] = useState(false);
    const [emiAmountDiscount,setEmiAmountDiscount]=React.useState("")
    const [bounceChargesDiscount,setBounceChargesDiscount]=React.useState("")
    const [penaltyDiscount,setPenaltyDiscount]=React.useState("")
    const [preClosureAmount,setPreClosureAmount]=React.useState("")
    const [preClosureCharges,setPreClosureCharges]=React.useState("")
    const [preclosureDiscount, setPreclosureDiscount] = React.useState("");

    const [bounceDiscountError, setBounceDiscountError] = useState('');
    const [penaltyDiscountError, setPenaltyDiscountError] = useState('');
    const [isGenerating, setIsGenerating] = useState(false);

    // --- Calculate max allowable discounts ---
    const maxBounceDiscount = chequeBounceCharges - discountedBounce - paidBounce;
    const maxPenaltyDiscount = overdueCharges - discountedPenalty - paidPenalty;

    const popUpStatusForm = () => {
        setStatusOpen(true);
        calculateTotalAmount()
        setBounceChargesDiscount("")
        setPenaltyDiscount("")
        setEmiAmountDiscount("")
        setLumpsumAmount("")
        setTotalAmount("")
        setPreclosureDiscount("");
        setBounceDiscountError('');
        setPenaltyDiscountError('');
      };
      const calculateTotalAmount = () => {
        // 
        const emi = parseFloat(totalEmiAmount) || totalEmiAmount;
        let discount = parseFloat(discountAmount) || 0;
        const maxDiscount = parseFloat(overdueCharges) + parseFloat(chequeBounceCharges) + parseFloat(interest);
        if (discount > maxDiscount) {
          discount = maxDiscount >= 0 ? maxDiscount : 0;
      }
      const validBounceDiscount = bounceDiscountError ? 0 : (parseFloat(bounceChargesDiscount) || 0);
      const validPenaltyDiscount = penaltyDiscountError ? 0 : (parseFloat(penaltyDiscount) || 0);
        const total = emi  - validBounceDiscount-emiAmountDiscount-validPenaltyDiscount;
        setTotalAmount(total);
      };
      // 
    const calculatePreCloseAmount = () => {
        const validBounceDiscount = bounceDiscountError ? 0 : (parseFloat(bounceChargesDiscount) || 0);
        const validPenaltyDiscount = penaltyDiscountError ? 0 : (parseFloat(penaltyDiscount) || 0);
        const netAmount = (totalEmiAmount -validBounceDiscount-emiAmountDiscount-validPenaltyDiscount-discountedBounce-discountedPenalty-paidBounce-paidPenalty);
        const preCloseCharges = (totalEmiAmount + chequeBounceCharges + overdueCharges-validBounceDiscount-emiAmountDiscount-validPenaltyDiscount-discountedBounce-discountedPenalty-paidBounce-paidPenalty)*((loanDetails?.preCloseCharges)/100);
        const parsedPreclosureDiscount = parseFloat(preclosureDiscount) || 0;
        const preCloseAmount = Number(totalEmiAmount) + ((loanDetails?.facilityType === 1 || loanDetails?.facilityType === 5)?0:Number(foreCloseAmount))- parsedPreclosureDiscount;
        setPreClosureAmount(preCloseAmount)
        const calculatedPreClosureCharges = Number(foreCloseAmount) - parsedPreclosureDiscount;
        setPreClosureCharges(calculatedPreClosureCharges)
        
      };
      useEffect(() => {
        if (isPreClosure) {
          setRepaymentType(1); 
        }
      }, [isPreClosure]);
       useEffect(() => {
        calculateTotalAmount();
        calculatePreCloseAmount();
    }, [amount, penaltyAmount, bounceCharges, discountAmount, totalEmiAmount, emiAmountDiscount, bounceChargesDiscount, penaltyDiscount, preclosureDiscount, isPreClosure]);
      const resetForm = () => {
        setTotalAmount(0)
        setamount('');
        setPenaltyAmount('');
        setBounceCharges('');
        setDiscountAmount('');
        setTotalAmount(0);
        setPreclosureDiscount("");;
      };
      const user = null
      const { loanid } = useSelector(state => state.appContext);

      const handleBounceDiscountChange = (event) => {
      const value = event.target.value;
      setBounceChargesDiscount(value);
  
      const numericValue = parseFloat(value) || 0;
  
      if (numericValue > maxBounceDiscount) {
        setBounceDiscountError(`Max discount is ${maxBounceDiscount.toFixed(2)}`);
      } else {
        setBounceDiscountError('');
      }
    };

    const handlePenaltyDiscountChange = (event) => {
      const value = event.target.value;
      setPenaltyDiscount(value);
  
      const numericValue = parseFloat(value) || 0;
  
      if (numericValue > maxPenaltyDiscount) {
        setPenaltyDiscountError(`Max discount is ${maxPenaltyDiscount.toFixed(2)}`);
      } else {
        setPenaltyDiscountError('');
      }
    };
    
    const isFormInvalid = !!bounceDiscountError || !!penaltyDiscountError;
  // const handleSubmitCustomAmount = () => {
  //   if (!lumpsumAmount || Number(lumpsumAmount) <= 0) {
  //     alert("Please enter valid custom amount");
  //     return;
  //   }

  //   if (!selectedItems || selectedItems.length === 0) {
  //     alert("Please select at least one EMI");
  //     return;
  //   }

  //   const customData = {
  //     userId: loanDetails.userId,
  //     loanId: loanid,
  //     legacyLoanId: loanDetails?.legacyLoanId,
  //     emiId: selectedItems[0],
  //     amount: Number(lumpsumAmount),
  //   };

  //   setIsGenerating(true);

  //   axiosInstance
  //     .post('/loan-repayment/custom-payment-amount', customData)
  //     .then((res) => {
  //       if (res.data.message === "Successful") {
  //         alert("Custom amount submitted successfully.");
  //       }
  //     })
  //     .catch((err) => {
  //       alert(err?.response?.data?.message || "Failed to submit custom amount.");
  //     })
  //     .finally(() => {
  //       setIsGenerating(false);
  //     });
  // };
      const handlePayment = () => {
      const validBounceDiscount = bounceDiscountError ? 0 : (parseFloat(bounceChargesDiscount) || 0);
      const validPenaltyDiscount = penaltyDiscountError ? 0 : (parseFloat(penaltyDiscount) || 0);
        const isOverdue = RepaymentType === 3 && (selectedEmiStatuses || []).some(s => s === 5);
        const formData = {
          loanId:loanid,
          amount:lumpsumAmount?lumpsumAmount:isPreClosure?preClosureAmount:(principle+interest-paidInterest-paidPrinciple + chequeBounceCharges + overdueCharges-validBounceDiscount-emiAmountDiscount-validPenaltyDiscount-discountedPenalty-discountedBounce-paidBounce-paidPenalty),
          reason : isOverdue ? 2 : RepaymentType,
          penaltyDiscount:Number(validPenaltyDiscount?validPenaltyDiscount:0),
          bounceDiscount:Number(validBounceDiscount?validBounceDiscount:0),
          emiIds:selectedItems,
          whatsappNotification:1,
          emailNotification:1,
          remarks:"",
          preclosureDiscount:Number(preclosureDiscount?preclosureDiscount:0)
        };
        setIsGenerating(true);
        const paymentUrl = `/loan-repayment/payment-link`;
        axiosInstance
        .post(`${paymentUrl}`, formData, {
          headers: {
            'Content-type': 'application/json',
          },
        })
        .then(
          (res) => {
            if (res.data.message === 'Successful') {
                // setPaymentLink(res?.data?.data)
                // setShowPaymentLinkModal(true);
                if (res?.data?.data) alert('Link generated successfully and customer notified.')
              }
          },
          (error) => {
            alert(error?.response?.data?.message || 'Failed to generate payment link.')
          },
        ).catch((err)=>{
          alert(err?.response?.data?.message || 'Failed to generate payment link.')
        }).finally(() => {
          setIsGenerating(false);
          setStatusOpen(false);
        })

    };

    const copyToClipboard = () => {
      navigator.clipboard.writeText(paymentLink);
      alert('Payment link copied to clipboard!');
      // setTimeout(() => window.location.reload(true), 500);
    };
    const  togglePaymentLinkModal = ()=>{
      setShowPaymentLinkModal(!showPaymentLinkModal)
        }

    // 

    return(
        <div >
          <p style={{  fontSize: '14px',color:'#314158',lineHeight:1  }}  onClick={() => selectedItems?.length>=1 || isPreClosure?popUpStatusForm():null}>
            Payment Link
          </p>
            <Modal  isOpen={false}>
                <ModalHeader>Waiting For Confirmation</ModalHeader>
                <ModalBody>{confirmationMessage}</ModalBody>
            </Modal>
            <Modal isOpen={showPaymentLinkModal} toggle={togglePaymentLinkModal} backdrop="static" style={{top:'10%'}}>
        <ModalHeader toggle={togglePaymentLinkModal}>Payment Link</ModalHeader>
        <ModalBody>
          {/* <p style={{fontFamily:'Inter-Medium'}}> {paymentLink}{" "}
          <span onClick={copyToClipboard} style={{ cursor: 'pointer' }}>
              <img src={copy} style={{height:'20px',width:'20px',marginLeft:'50px'}} title='copy to clipboard' alt=""/>
            </span>
          </p> */}
          <p style={{fontFamily:'Inter-Medium', textAlign:'center'}}>Link generated successfully and customer notified.</p>
        </ModalBody>
      </Modal>
            {formStatusOpen && (
                <>
                <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 999,
                        }}>
                </div>
                 <Modal style={{
                    
                    width:"500px",
                    
                    top:"4%",
                    borderRadius:"10px",
                }} isOpen={formStatusOpen}>
                  {loanDetails.mandateActive === true ? 
                  <>
                  <div style={{backgroundColor:'#E9E9E9',borderTopLeftRadius:'10px',borderTopRightRadius:'10px'}}>
                    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'20px',height:'60px',paddingRight:'20px',paddingTop:'10px'}}>
                        <p style={{fontFamily:'Inter-Medium',fontSize:'20px',fontWeight:'600',color:'#101828'}}>Payment Link</p>
                        <p style={{paddingBottom:'10px'}}><img src={close} style={{cursor:'pointer'}} alt="" onClick={() => {resetForm();setStatusOpen(!formStatusOpen);}} /></p>
                    </div>
                    </div>
                    <ModalBody style={{color:'red',fontFamily:'Inter',fontSize:'14px'}}>
                    Mandate is active,cannot generate the payment link.
                    </ModalBody>
                   
                  </>:
                  <>
                  <div style={{backgroundColor:'#E9E9E9',borderTopLeftRadius:'10px',borderTopRightRadius:'10px'}}>
                    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'20px',height:'60px',paddingRight:'20px',paddingTop:'10px'}}>
                        <p style={{fontFamily:'Inter-Medium',fontSize:'20px',fontWeight:'600',color:'#101828'}}>Payment Link</p>
                        <p style={{paddingBottom:'10px'}}><img src={close} alt="" style={{cursor:'pointer'}} onClick={() => {resetForm();setStatusOpen(!formStatusOpen);}} /></p>
                    </div>
                    </div>
                <ModalBody>
                <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
                <Grid item xs={6}>
                <TextField label="Total Remaining Emi Amount" variant="outlined" InputLabelProps={{style: { fontSize: '12px' },shrink: true}} value={isPreClosure ? totalEmiAmount:principle+interest-paidInterest-paidPrinciple} disabled/>
                </Grid>
                <Grid item xs={6}>
                <TextField label="Emi Amount Discount"  variant="outlined"  InputLabelProps={{style: { fontSize: '12px' }}} disabled  value={emiAmountDiscount} onChange={(event)=>{setEmiAmountDiscount(event.target.value)}}/>
                </Grid>
                </Grid>
                <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
                <Grid item xs={6}>
                <TextField label="Total Bounce Charges" variant="outlined" InputLabelProps={{style: { fontSize: '12px' },shrink: true}} value={chequeBounceCharges-discountedBounce-paidBounce} disabled/>
                </Grid>
               
                <Grid item xs={6}>
                <TextField label="Bounce Chrgs Discnt" variant="outlined" InputLabelProps={{style: { fontSize: '12px' }}} value={bounceChargesDiscount} disabled={RepaymentType ===4} onChange={handleBounceDiscountChange} error={!!bounceDiscountError} helperText={bounceDiscountError}/>
                </Grid>
                </Grid>
                <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
                <Grid item xs={6}>
                <TextField label="Total Penlty" variant="outlined" InputLabelProps={{style: { fontSize: '12px' },shrink: true}} value={overdueCharges-discountedPenalty-paidPenalty} disabled/>
                </Grid>
                <Grid item xs={6}>
                <TextField label="Penlty Discount" variant="outlined" InputLabelProps={{style: { fontSize: '12px' }}} value={penaltyDiscount} disabled={RepaymentType ===4} onChange={handlePenaltyDiscountChange} error={!!penaltyDiscountError} helperText={penaltyDiscountError}/>
                </Grid>
                </Grid>
                {/* <p style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',paddingLeft:'10px',fontWeight:'600',paddingTop:'10px' }}>Legal Charges: </p> */}
                <Grid container spacing={2} paddingLeft="10px" paddingRight="10px">
                <Grid item xs={6}>
                <Typography gutterBottom style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',fontWeight:'500' }}>Select Category</Typography>

                <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select" onChange={(e) => setRepaymentType(e.target.value)} value={RepaymentType} style={{border:'none',fontSize:'14px',color:'gray'}}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxWidth: 200,
                        },
                      },
                    }}
                  >
                    <MenuItem value="Select">Select</MenuItem>
                    <MenuItem value={1}>Preclosure</MenuItem>
                    {/* <MenuItem value={2}>Overdue</MenuItem> */}
                    <MenuItem value={3}>EmiRepayment</MenuItem>
                    <MenuItem value={4}>Custom Amount</MenuItem>
                    <MenuItem value={5}>Settlement</MenuItem>
                    {/* <MenuItem value={6}>Refund By Institute</MenuItem> */}
                  </Select>
                </FormControl>
              </Box>          
                </Grid>
                <Grid item xs={6} marginTop="35px">
                  {RepaymentType === 4 ? (
                <TextField label="Enter Amount" variant="outlined" InputLabelProps={{style: { fontSize: '12px' }}} value={lumpsumAmount} onChange={(e) => setLumpsumAmount(e.target.value)}/>
                  ):(
                    <TextField label="Net Amount" variant="outlined" InputLabelProps={{style: { fontSize: '12px' }}} value={isPreClosure
                  ? (totalEmiAmount - (bounceDiscountError ? 0 : bounceChargesDiscount) - emiAmountDiscount - (penaltyDiscountError ? 0 : penaltyDiscount) - discountedBounce - discountedPenalty - paidBounce - paidPenalty)
                  : (principle + interest - paidInterest - paidPrinciple + chequeBounceCharges + overdueCharges - (bounceDiscountError ? 0 : bounceChargesDiscount) - emiAmountDiscount - (penaltyDiscountError ? 0 : penaltyDiscount) - discountedBounce - discountedPenalty - paidBounce - paidPenalty)
                  } disabled/>
                  )}
                </Grid>
                </Grid>
                {(isPreClosure &&(loanDetails?.facilityType !== 1 && loanDetails?.facilityType !== 5))&& (
                  <>
                  <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
                    {/* <Grid item xs={6}>
                        <TextField 
                            label="Future Interest" 
                            variant="outlined"  
                            InputLabelProps={{style: { fontSize: '12px' }}} 
                            value={futureInterest} 
                            disabled
                        />
                    </Grid> */}
                    <Grid item xs={6}>
                        <TextField 
                            label="Preclosure Discount" 
                            variant="outlined"  
                            InputLabelProps={{style: { fontSize: '12px' }}} 
                            value={preclosureDiscount} 
                            onChange={(event)=>{setPreclosureDiscount(event.target.value)}}
                        />
                    </Grid>
                  </Grid>
                  </>
                  
                )}
                
                {/* --- Correctly Formatted Total Amount Summary --- */}
                <Grid container>
                  <Grid item xs={12} paddingLeft="10px" paddingRight="10px" marginTop="1rem">
                    {isPreClosure && (
                      <Box>
                         <Typography sx={{ fontWeight: 'bold' }}>
                          Future Interest:{' '}
                          <Box component="span" sx={{ fontWeight: 'normal', mr: 1 }}>
                            {futureInterest}
                          </Box>

                          <Box component="span" sx={{ mx: 1 }}>
                            |
                          </Box>

                          Savings:{' '}
                          <Box component="span" sx={{ fontWeight: 'normal' ,color: "#009966",backgroundColor: "#ecfdf5",border: "1px solid #d0fae5",padding:'5px'}}>
                            {Number(futureInterest) - Number((loanDetails?.facilityType === 1 || loanDetails?.facilityType === 5)?0 :preClosureCharges)}
                          </Box>
                        </Typography>
                        <Typography sx={{ fontWeight: 'bold' }}>
                          Preclose Charges: <Box component="span" sx={{ fontWeight: 'normal' }}>
                            {(preClosureCharges || 0).toFixed(2)}
                            {(loanDetails?.facilityType === 1 || loanDetails?.facilityType === 5) ? " (Waived Off)" : ""}
                          </Box>
                        </Typography>
                        <Typography sx={{ fontWeight: 'bold', mt: 0.5 }}>
                          Total Amount : <Box component="span" sx={{ fontWeight: 'normal' }}>{(preClosureAmount || 0).toFixed(2)}</Box>
                        </Typography>
                      </Box>
                    )}
                  </Grid>
                </Grid>
                    {/* <Grid
                      container
                      display="flex"
                      justifyContent="center"
                      gap="15px"
                      paddingBottom="15px"
                    >
                      {RepaymentType === 4 && (
                        <Grid item>
                          <Button
                            style={{
                              backgroundColor: isGenerating ? '#cccccc' : '#D32028',
                              marginTop: '2rem',
                              color: 'white',
                              cursor: isGenerating ? 'not-allowed' : 'pointer'
                            }}
                            onClick={handleSubmitCustomAmount}
                            disabled={isGenerating}
                          >
                            {isGenerating ? 'Submitting...' : 'Submit Custom Amount'}
                          </Button>
                        </Grid>
                      )}

                      <Grid item>
                        <Button
                          style={{
                            backgroundColor: (isFormInvalid || isGenerating) ? '#cccccc' : '#D32028',
                            marginTop: '2rem',
                            color: 'white',
                            cursor: (isFormInvalid || isGenerating) ? 'not-allowed' : 'pointer'
                          }}
                          onClick={handlePayment}
                          disabled={isFormInvalid || isGenerating}
                        >
                          {isGenerating ? 'Generating link...' : 'Generate Link'}
                        </Button>
                      </Grid>
                    </Grid> */}
                    <Grid container
                      display="flex"
                      justifyContent="center"
                      gap="15px"
                      paddingBottom="15px">
                      <Button
                        style={{
                          backgroundColor: (isFormInvalid || isGenerating) ? '#cccccc' : '#D32028',
                          marginTop: '2rem',
                          color: 'white',
                          cursor: (isFormInvalid || isGenerating) ? 'not-allowed' : 'pointer'
                        }}
                        onClick={handlePayment}
                        disabled={isFormInvalid || isGenerating}
                      >
                        {isGenerating ? 'Generating link...' : 'Generate Link'}
                      </Button>
                    </Grid>

                </ModalBody>

                  </>}
                    
                </Modal>
                </>
            )}
        </div>
    )
}